module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_warning_round_red-eebd1db6b5f57862a005b10cf08f1f8f.svg";